import { render, staticRenderFns } from "./CertificateView.vue?vue&type=template&id=ef32afa4&scoped=true"
import script from "./CertificateView.vue?vue&type=script&lang=js"
export * from "./CertificateView.vue?vue&type=script&lang=js"
import style0 from "./CertificateView.vue?vue&type=style&index=0&id=ef32afa4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef32afa4",
  null
  
)

export default component.exports